// extracted by mini-css-extract-plugin
export var lg = "_f2-7";
export var md = "_f2-6";
export var placeholderContainer = "_f2-1";
export var placeholderIcon = "_f2-2";
export var productImage = "_f2-0";
export var sm = "_f2-5";
export var xl = "_f2-8";
export var xs = "_f2-4";
export var xxs = "_f2-3";